export default {
  path: 'contracts',
  name: 'Contracts',
};
